import { Directive } from '@angular/core';
export class InputTextLabelDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-input-text-label'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputTextLabelDirective_tsickle_Closure_declarations() {
/** @type {?} */
InputTextLabelDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputTextLabelDirective.ctorParameters;
}

export class InputTextAddonLeftDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-input-text-addon-left'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputTextAddonLeftDirective_tsickle_Closure_declarations() {
/** @type {?} */
InputTextAddonLeftDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputTextAddonLeftDirective.ctorParameters;
}

export class InputTextAddonRightDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-input-text-addon-right'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputTextAddonRightDirective_tsickle_Closure_declarations() {
/** @type {?} */
InputTextAddonRightDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputTextAddonRightDirective.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
